import React from 'react'
import Line37 from '../../assets/images/line37.png'

export default function Footer() {
  return (
    <div className='flex flex-end'>
        <img id="logo" src={Line37} className="w-full h-3 fixed bottom-0" />
    </div>
  )
}